module.exports = __webpack_public_path__ + "static/media/product3-1.00fcd5a4.png";